import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ToastyService } from 'ng2-toasty';
import { map } from 'rxjs/operators';
import { GuidHelper } from '../helpers/guid-helper';
import { NotificationType } from '../models/notification/notification';
import { Notify } from '../state-manager/actions/notification.action';
import { AuthState } from '../state-manager/state/auth.state';

@Injectable()
export class GeolocationService {
    constructor(
        private store: Store
    ) {}

    async checkPermission(): Promise<boolean> {
        return await (navigator as any).permissions
            .query({ name: 'geolocation' })
            .then((value) => {
                if (value.state === 'denied') {
                    this.store.dispatch(
                        new Notify({
                            id: GuidHelper.generate(),
                            type: NotificationType.Warning,
                            title: 'Serviço de Localização desativado',
                            timeout: 7000,
                            showClose: true,
                            theme: 'bootstrap',
                            msg: 'Ativar o serviço de localização é super importante para checarmos a autenticidade / veracidade do seu cadastro.'
                        })
                    );

                    return false;
                }

                return true;
            });
    }

    async checkExternalUserHasGeolocationPermission() {
        this.store
            .select(AuthState.HASH)
            .pipe(
                map(async (hash: string) => hash ? await this.checkPermission() : [])
            ).subscribe();
    }
}
